import { isZAWPage } from 'helpers/zaw';
import { FEATURE_ENABLED_VARIANT_NAME_TREATMENT } from 'constants/features';
import { checkIsHomepage } from 'history/historyFactory';
import { PDP_PATH_RE } from 'common/regex';
import { marketplace } from 'helpers/MarketplaceSetupUtils';

export const isPdpUrl = (url: string) => PDP_PATH_RE.test(url);

const phase1List = [
  '/c/customer-service',
  '/c/about',
  '/c/adaptive',
  '/c/associates-program',
  '/c/contact-us',
  '/c/content-usage-terms',
  '/c/customer-reviews',
  '/c/privacy-policy',
  '/c/shipping-and-delivery-questions',
  '/c/shipping-and-returns',
  '/c/terms-of-use',
  '/c/vip-faqs',
  '/c/vip-terms-and-conditions',
  '/c/zappos-for-good-faq',
  '/c/zappos-gift-cards',
  '/c/zappos-insights',
  '/c/zaw-amazon-faq',
  '/c/zaw-returns'
];

const p2List = [
  '/c/outdoor',
  '/c/ugg',
  '/c/crocs',
  '/c/coupon',
  '/c/return-trans-options',
  '/c/hoka-shoes',
  '/c/new-balance-001',
  '/c/on',
  '/c/brands'
].concat(phase1List);
const doNotRedirectList = ['/c/e-gift-cards', '/c/vip-dash'];

function isInATreatment(variation: string) {
  return ['treatment', 'phase2', 'phase3'].includes(variation);
}
export const redirectLandingPageToKratos = ({
  currentPath,
  multivariateExperimentVariation,
  isHomepageExperiment,
  search
}: {
  currentPath: string;
  // treatment is phase 1 since we didn't plan ahead
  multivariateExperimentVariation: 'control' | 'treatment' | 'phase2' | 'phase3';
  isHomepageExperiment: boolean;
  search?: URLSearchParams;
}) => {
  if (
    isInATreatment(multivariateExperimentVariation) &&
    ((multivariateExperimentVariation === FEATURE_ENABLED_VARIANT_NAME_TREATMENT && phase1List.includes(currentPath)) ||
      (multivariateExperimentVariation === 'phase2' && p2List.includes(currentPath)) ||
      (multivariateExperimentVariation === 'phase3' &&
        !doNotRedirectList.includes(currentPath) &&
        !isZAWPage(currentPath) &&
        !checkIsHomepage(currentPath)))
  ) {
    // URLSearchParams has a size field but it's relatively recent so need a different way to determine if there are any parameters
    const queryString = search ? search.toString() : '';
    const redirectPath = queryString ? `/kratos${currentPath}?${queryString}` : `/kratos${currentPath}`;

    return {
      isRedirected: true,
      redirectPath
    };
  } else if (isHomepageExperiment && checkIsHomepage(currentPath)) {
    // homepage always redirects to the explicit /c/ route because /kratos/ does not work in zfc land
    const queryString = search ? search.toString() : '';
    const redirectPath = `/kratos/c/zappos-homepage${queryString ? `?${queryString}` : ''}`;

    return {
      isRedirected: true,
      redirectPath
    };
  }

  return {
    isRedirected: false
  };
};

interface RedirectToKratosOptions {
  currentPath: string;
  variant: string;
  search?: URLSearchParams;
  isZapposOnly?: boolean;
  pathValidator?: (path: string) => boolean;
}

export const redirectToKratos = ({ currentPath, variant, search, isZapposOnly = true, pathValidator = () => true }: RedirectToKratosOptions) => {
  if (isZapposOnly && marketplace() === '6pm') {
    return { isRedirected: false };
  }

  if (variant === FEATURE_ENABLED_VARIANT_NAME_TREATMENT && pathValidator(currentPath)) {
    const queryString = search ? search.toString() : '';
    const redirectPath = queryString ? `/kratos${currentPath}?${queryString}` : `/kratos${currentPath}`;

    return { isRedirected: true, redirectPath };
  }

  return { isRedirected: false };
};
